import { Badge } from '@mantine/core'
import { transparentize } from 'polished'
import React from 'react'
import {
  BORDER_WIDTH,
  COLOR_INTENT,
  FONT_SIZE,
  FONT_WEIGHT,
  LINE_HEIGHT,
  SPACE,
  Z_INDEX,
} from 'Theme'

export const BlackFridayBadge = () => (
  <Badge
    variant="filled"
    radius="4px"
    size="md"
    tt="initial"
    styles={() => ({
      root: {
        zIndex: Z_INDEX.SOLD_OUT_BADGE,
        fontSize: FONT_SIZE.PX_13,
        fontWeight: FONT_WEIGHT.MEDIUM,
        lineHeight: LINE_HEIGHT.S,
        color: COLOR_INTENT.COLLECTION_WIDGET_CARD.BLACK_FRIDAY_BADGE.TEXT,
        backgroundColor:
          COLOR_INTENT.COLLECTION_WIDGET_CARD.BLACK_FRIDAY_BADGE.BACKGROUND,
        border: `${BORDER_WIDTH.PX_1} solid
            ${transparentize(
              0.9,
              COLOR_INTENT.COLLECTION_WIDGET_CARD.BLACK_FRIDAY_BADGE.TEXT
            )}`,
        padding: `${SPACE.PX_4} ${SPACE.PX_9}`,
      },
    })}
  >
    Black Friday Sale
  </Badge>
)
